import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import FontBody2 from '../../fonts/font-body2/font-body2';
import FontHeading2 from '../../fonts/font-heading2/font-heading2';
import FontHeading4 from '../../fonts/font-heading4/font-heading4';
import IconDiscard from '../../icons/icon-discard/icon-discard';
import { ButtonIcon } from '../../inputs/button-icon/button-icon';
import currentAccountStore from '../../../pages/accounts/stores/current-account-store';
import { ErrorStore } from '../error-modal-store';
import './api-error.scss';

const IconDiscardGrey = () => ( <IconDiscard color="var(--color-neutral-3)" />);

interface IProps {
    error: ErrorStore;
}

export const ApiError: React.FC<IProps> = observer(({ error }) => {
    const contentHeight = useRef<number>(0);
    const contentElem = useRef<HTMLDivElement>(null);

    const onCloseClicked = () => {
        error.remove();
    }

    useEffect(() => {
        contentHeight.current = (contentElem.current?.offsetHeight ?? 0);
    }, [contentElem.current?.offsetHeight])

    const heightStyle = () => {
        if (['visible', 'leaving'].includes(error.state) && (contentHeight.current ?? 0) > 0) {
            return { maxHeight: `${(contentHeight.current ?? 0) + 40}px` };
        }
        return {};
    }
 
    const isSysAdmin = currentAccountStore.isSysAdmin;

    return (
        <div className={`api-error ${error.state ?? ''}`}
            onMouseEnter={() => error.stop()}
            onMouseLeave={() => error.start()}
            style={heightStyle()}
        >
            <ButtonIcon Component={IconDiscardGrey} onClick={onCloseClicked} />

            <div ref={contentElem} className="err-content">
                <FontHeading2>{error.title}</FontHeading2>
                {error.message && <FontHeading4>{(isSysAdmin && error.code) ? `${error.code}: ` : ''} {error.message}</FontHeading4>}
                {(isSysAdmin && error.raw_message) && <FontBody2><b>Original error:</b> {error.raw_message}</FontBody2>}
                {error.trace_id && <FontBody2><b>Reference ID:</b> {error.trace_id}</FontBody2>}
                {(isSysAdmin && !error.external_api_error && error.url) && <FontBody2><b>url:</b> {error.url}</FontBody2>}
                {(isSysAdmin && !error.external_api_error && error.file) && <FontBody2><b>file:</b> {error.file}; {error.line}</FontBody2>}
            </div>

        </div>
    )
});
